import { FC } from 'react';

import { clsx } from 'clsx';

import { useYandexPayLoaded } from '@app/layouts/YandexPayProvider/YandexPayProvider';
import { YANDEX_MERCHANT_ID } from '@shared/constants/global';
import { Skeleton } from '@shared/ui/Skeleton';

import cls from './YandexSplitBadge.module.scss';

type YandexSplitBadgeProps = {
  price: number;
  className?: string;
};

export const YandexSplitBadge: FC<YandexSplitBadgeProps> = ({ price, className }) => {
  const loaded = useYandexPayLoaded();

  return (
    <div className={clsx(cls.wrapper, className, { [cls.loading]: !loaded })}>
      {loaded ? (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        <yandex-pay-badge
          merchant-id={YANDEX_MERCHANT_ID}
          type="bnpl"
          amount={price}
          size="m"
          variant="simple"
          theme="light"
          align="left"
          color="grey"
        />
      ) : (
        <Skeleton />
      )}
    </div>
  );
};
